import { RootState } from "../rootReducer"

export const selectAuthStatus = (state: RootState) => state.auth.authenticated
export const selectAuthRequested = (state: RootState) => state.auth.authRequested
export const selectLoginState = (state: RootState) => state.auth.login
export const selectLogoutState = (state: RootState) => state.auth.logout
